import { render, staticRenderFns } from "./InvoicesFilter.vue?vue&type=template&id=a565c896&scoped=true"
import script from "./InvoicesFilter.vue?vue&type=script&lang=js"
export * from "./InvoicesFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a565c896",
  null
  
)

export default component.exports